import type { UseFormReset } from 'react-hook-form';
import type { RuleTargetType } from '../ruleTypes';
import type { RuleFormValues } from './ruleFormSchema';

export const applyRuleTargetTypeChange = ({
  nextType,
  currentType,
  getValues,
  reset,
  onClearTestSnapshot,
}: {
  nextType: RuleTargetType;
  currentType: RuleTargetType;
  getValues: () => RuleFormValues;
  reset: UseFormReset<RuleFormValues>;
  onClearTestSnapshot: () => void;
}): void => {
  if (nextType === currentType) {
    return;
  }

  reset(
    {
      ...getValues(),
      type: nextType,
      conditions: [],
      inherit: false,
    },
    { keepDirty: true, keepTouched: true },
  );
  onClearTestSnapshot();
};
